import { useHasPermission } from '@app/core/auth/authorization/hooks/useHasPermission';
import { AuthUser } from '@app/core/types/users';
import { auditReports } from '@mi-front/api-clients';
import { cleanQuery, Report, UserRole } from '@mi-front/core';
import { noop } from 'lodash';

export const GIP_QUERY_PARAM_SEPARATOR = ';;';

export function convertReportConfigToQueryParams(
  config: auditReports.GipReportDataDto,
): Record<string, any> {
  const allStationsSelected = !config.stationsIds?.length;

  let customFieldKey = null;
  for (customFieldKey in config.customFields) {
    noop();
  }

  return cleanQuery({
    from: config.from,
    to: config.to,
    stations: allStationsSelected ? '' : config.stationsIds?.join(','),
    advertisers: config.advertisers?.join(GIP_QUERY_PARAM_SEPARATOR) || '',
    campaigns: config.campaigns?.join(GIP_QUERY_PARAM_SEPARATOR) || '',
    versions: config.versions?.join(GIP_QUERY_PARAM_SEPARATOR) || '',
    customFieldKey,
    customFieldValue: customFieldKey ? config.customFields?.[customFieldKey] : null,
    orders: config.orders?.join(',') || '',
  });
}

export function useCanDeleteReport(user: AuthUser, report: Report): boolean {
  const canDelete = useHasPermission(auditReports.AuditReportsPermissions.Reports_Manage);

  if (user.role === UserRole.SUPERADMIN || user.role === UserRole.CLIENT_ADMIN) {
    return true;
  }

  return !!canDelete;
}
